export default __webpack_public_path__ + "static/media/GovMIC_Site_Logo.f9d55820.png";